import React, { useState, useEffect, useContext, Fragment } from "react";
import { Button } from "react-bootstrap";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ListFilters from 'components/sales/ListFilters/ListFilters';

const RcTransferList = ({
  getAllRcTransfer,
  rcTransferListing = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [roleId,setRoleId] = useState('');


  const Headers = [
    "Vehicle Number",
    "Appointment Date",
    "User ID",
    "Status",
    "Action"
  ];

  useEffect(() => {
    const fetchData = async () => { 
        setIsLoading(true); 
        await getAllRcTransfer(1, null, null, null);
        setIsLoading(false); 
    };
    fetchData(); 
  }, []); 
  

  console.log('table data:', rcTransferListing?.data)
  useEffect(() => {
    const tableData = [
      'id',
      'vehicle_number',
      'appointment_date',
      'user_id',
      'lead_status'
    ];

    setListData()
    if (rcTransferListing && rcTransferListing?.data) {
      const data = rcTransferListing?.data?.resultSets?.map((element) =>
          Object.assign(
              {},
              ...tableData.map((key) => (
                  {
                   [key]: element[key],
                  })

              ),{Action: [
                  {
                    name : 'View details', 
                    link: `${baseUrl}/rc-transfer-view/${element.lead_id}`,
                  }
                 
                  ]
                }
          )
      );
      data && setListData(data);
      setPageCount(Math.ceil(rcTransferListing?.data?.total / rcTransferListing?.data?.to));
    }
  }, [rcTransferListing]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("getRcTransferListing", JSON.stringify(filterData));
    // console.log('filterData:',filterData);
    // return false;
    setIsLoading(true);
    setFilterData(filterData);
    await getAllRcTransfer(1, null, filterData?.vehicle_number, filterData?.lead_status);
    setIsLoading(false);
    filterToggle();
  };



  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      (async () => {
        if(localStorage.getItem('roles')){
          const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
          setRoleId(roles);
        }
      
      })();
      setIsLoading(false);
    }, 1000);
  }, []);

  const headerBtns = () => (
    <Fragment>
      <Button
        onClick={filterToggle}
        className="filter-hamburger filter-btn btn btn-transparent"
      >
        <img src={Images?.Filter} alt="" />
        {localization.showFilters}
      </Button>
    </Fragment>
  );

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getAllRcTransfer(val.selected + 1, filter);
    localStorage.setItem('page', val.selected + 1)
    setIsLoading(false);
};

  return (
    <Layout
      title={localization.rcTransferList}
      Buttons={headerBtns}
      className={false ? "requiredFileds" : ""}
      // isGoback
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        headers={Headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        isId={false}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        dcTransferFilter={true}
      />
    </Layout>
  );
};

export default RcTransferList;

